module.exports = __webpack_public_path__ + "static/media/right-blue-arrow.22fbb489.svg";